export default __webpack_public_path__ + "static/media/Line3.afdb23d7.svg";